module.exports = new __parcel__URL__("interesting_owl.ea3ce292.webp").toString();